import React from 'react';
import gql from 'graphql-tag';
import className from 'classnames';
import { ShopCardFields } from '../schemas/rql';
import { ShopBadges } from '@reverbdotcom/commons/src/components/shop_badges';
import { RCStarRating } from '@reverbdotcom/cadence/components';
import ShopSvg from '@reverbdotcom/cadence/images/brand/my-shop-orange.svg';

interface IProps {
  shop: ShopCardFields.Fragment;
}

export const COMPONENT_NAME = 'ShopCard';

function ShopCard({ shop }: IProps) {
  const avatarUrl = shop.user.avatar?.source;
  const imageClasses = className(
    'shop-card__image',
    { 'shop-card__image--placeholder': !avatarUrl },
  );

  return (
    <div
      className="shop-card"
      itemType="https://schema.org/Store"
    >
      <div className={imageClasses}>
        <img
          src={avatarUrl || ShopSvg}
          alt=""
        />
      </div>
      <div className="shop-card__title">
        {shop.name}
      </div>
      <div className="shop-card__location">
        {shop.address.displayLocation}
      </div>
      <RCStarRating
        rating={shop.user.feedbackSummary.rollingRatingPercentage / 100}
        count={shop.user.feedbackSummary.receivedCount}
      />
      <div className="pt-1">
        <ShopBadges
          preferredSeller={shop.preferredSeller}
          quickShipper={shop.quickShipper}
          hideLabels
          smallBadges
        />
      </div>
    </div>
  );
}

export const ShopCardFragment = gql`
  fragment ShopCardFields on Shop {
    _id
    name
    preferredSeller
    quickShipper
    address {
      displayLocation
    }
    user {
      _id
      avatar {
        source
      }
      feedbackSummary {
        rollingRatingPercentage
        receivedCount
      }
    }
  }
`;

export default ShopCard;
